import { useState } from "react";
import { trpc } from "../utils/trpc";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import TagSelector from "./TagSelector";
import "../styles/TagSelection.css";

interface Tag {
  id: number;
  name: string;
  category_id?: number;
}

function TagSelection() {
  const { session, isMember, isVenueOwner } = useAuth();
  const navigate = useNavigate();

  const [selectedTags, setSelectedTags] = useState<Tag[]>([]);
  const [error, setError] = useState<string | null>(null);

  // Get venue if needed
  const venues = trpc.venue.getMyVenues.useQuery(undefined, {
    enabled: !!session && isVenueOwner,
    retry: false,
  });

  const profileType = isMember
    ? "member"
    : isVenueOwner
    ? "venue_owner"
    : null;

  // Mutations
  const addTagsToMe = trpc.tags.addTagsToMe.useMutation();
  const addTagToVenue = trpc.tags.addTagToVenue.useMutation();

  const handleSubmit = async () => {
    if (selectedTags.length === 0) {
      setError("Please select at least one interest.");
      return;
    }

    try {
      if (profileType === "member") {
        await addTagsToMe.mutateAsync({
          tagIds: selectedTags.map((t) => t.id),
        });
      } else if (profileType === "venue_owner") {
        const venueId = venues.data?.[0]?.venue_id;

        if (!venueId) {
          setError("No venue found.");
          return;
        }

        await Promise.all(
          selectedTags.map((tag) =>
            addTagToVenue.mutateAsync({
              tagId: tag.id,
              venueId,
            })
          )
        );
      }

      navigate("/dashboard");
    } catch (err) {
      console.error("Failed to save interests:", err);
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="tag-selection signup-process">
      <section>
        <h2>Select Your Interests</h2>

        {/* Shared selector ui */}
        <TagSelector
          value={selectedTags}
          onChange={setSelectedTags}
          min={1}
        />

        {error && <p className="tag-error">{error}</p>}

        <button className="submit-btn" onClick={handleSubmit}>
          Continue
        </button>
      </section>
    </div>
  );
}

export default TagSelection;
